import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";

import StandaloneMapView from "@modules/Projects/pages/StandaloneMapView";
import { Breadcrumb } from "@components/Breadcrumb";
import { Weather } from "@modules/Weather";
import { ViewTypeButton } from "../Button";
import { getProject } from "@modules/Projects/services/projectCrud";
import { useProjectFilter } from "../../../../../context/ProjectFilterContext";

function IrrigationAreaPage({ project, setProject }) {
  const { pid } = useParams();
  const { mobile } = useSelector((state) => state.mobile);
  const nextProjectId = pid === "without-project" ? "without-project" : Number(pid);
  const { selectedProjectId, setSelectedProjectId } = useProjectFilter();
  const previousProjectIdRef = useRef(selectedProjectId);
  const shouldFetchProject =
    pid !== "without-project" && (!project || project?.id !== Number(nextProjectId));

  const { data: projectFetched } = useQuery(["project", pid], () => getProject(pid), {
    enabled: shouldFetchProject,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    onSuccess: (data) => {
      setProject?.(data);
    },
  });

  const effectiveProject = shouldFetchProject ? projectFetched : project;

  useEffect(() => {
    setSelectedProjectId(nextProjectId);

    return () => {
      setSelectedProjectId(previousProjectIdRef.current ?? null);
    };
  }, [pid, setSelectedProjectId]);

  const breadcrumbTitle = effectiveProject ? (
    <span className="d-inline-flex align-items-center gap-3 flex-wrap">
      <span>{effectiveProject.name}</span>
      <Weather weather={effectiveProject.weather} iconWidth={"1.2rem"} hideLabel />
    </span>
  ) : null;

  const mobileTopOffset = "calc(var(--ts-topbar-height) + 2.75rem)";
  const desktopTopOffset = breadcrumbTitle ? "8.75rem" : "4rem";

  return (
    <>
      {/* Desktop: full breadcrumb with title, weather, view controls */}
      {!mobile && breadcrumbTitle && (
        <Breadcrumb title={breadcrumbTitle} viewType={<ViewTypeButton id={pid} />} />
      )}

      {/* Mobile: compact view switcher in normal flow, no title/weather */}
      {mobile && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0.375rem 0.5rem",
            background: "var(--color-bg-surface, #f8f9fa)",
          }}
        >
          <ViewTypeButton id={pid} />
        </div>
      )}

      <StandaloneMapView topOffset={mobile ? mobileTopOffset : desktopTopOffset} />
    </>
  );
}

export default IrrigationAreaPage;
